import React, { useState, useContext, useReducer, useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import {useNavigate} from 'react-router-dom';
import dashboardbg from '../../assets/images/dashboard-bg.png';
import dashboard from '../../assets/images/dashboard.png';
import wishplus from '../../assets/images/wish-plus.png';
import { useAuth } from "../../hooks/customers/AuthProvider";
import Terms from "../Terms";
import {LoaderContext} from '../utils/Contexts';
import * as Config from '../../config/config';
import logintopimage1mob from '../../assets/images/mobilelayer_2.png';

function reducer(state, action) {
  if (action.type === 'valid') {
     return {
      valid: true,
      message: "",
    };
  } else {
     return {
      valid: false,
      message: action.message
    };
  }
  throw Error('Unknown action.');
}

const initialState = { message: '', valid: false };

export default function Login() { 
    const auth = useAuth();
    
    const { isLoader, setLoader } = useContext(LoaderContext);
    const [errMessage, setErrMessage] = useState(false);
    const [formData, setFormData] = useState({
        password: "",
        email: "",
        rememberMe: false
      });

      const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        formState: { errors },
      } = useForm();
      const onSubmit = (data) => {
        if (data) {
          setLoader(true);
          auth.loginAction(dispatch, data).catch((error) => {
            // Example: If login fails, dispatch an error action
            dispatch({ type: "error", message: "Invalid email or password." });
          })
          .finally(() => {
            setLoader(false);
          });
          
        }else {
          dispatch({ type: "error", message: "Email and password are required." });
        }
      }
      
      const [state, dispatch] = useReducer(reducer, initialState);

      const backgroundDash = {
        backgroundImage: `url(${dashboard})`,
      };
      const navigate = useNavigate();
      useEffect(() => {
      if(auth.token) {
        navigate(Config.REDIRECT_PAGE_AFTER_LOGIN);
      }
    }, []);

    // const handleInputChange = (e) => {
    //   dispatch({ type: "valid" }); // Clears the error message
    // };

     // Clear errors on input change
      const handleInputChange = (e) => {
        if(e.target.name === 'email')
        {
          clearErrors('email');
        }
        if(e.target.name === 'password')
        {
          clearErrors('password');
        }
        dispatch({ type: "valid" });
      };
      //console.log("Email:", watch("email"), "Password:", watch("password"));
   
    return (
      
        <div className="login-inside">
        <img src={dashboardbg} className="logintopimage1" alt="fruit"/>
        <img src={logintopimage1mob} className="hide logintopimage1 logintopimage1mob" alt="fruit"/>
        <div className="dashboardsec" style={backgroundDash}>
          <div className="dashboardsec_inner">
            <img src={wishplus} className="wish-plus" alt="fruit"/>
            <span className="dotted"></span>
            <h2>LOGIN ACCOUNT</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
            {state.message && !state.valid && !errors.email && !errors.password &&
               ( <div className="message error">
                    <p>{state.message}</p>
                </div>)
            }
              <input className="textfield"
            type="email"
            id="email"
            name="email"
            {...register("email",{ 
              required: "Email Address is required",
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "Invalid email"
              }
             })}
            aria-invalid={errors.email ? "true" : "false"}
            placeholder="Email Address"
            onBlur={(e)=>handleInputChange(e)} 
          />
          {errors.email && <span className="error-inline error-inline-input">{errors.email.message}</span>}
            <input className="textfield"
            type="password"
            id="password"
            name="password"
            {...register("password",{ required: "Password is required" })}            
            placeholder="Password"
            onBlur={(e)=>handleInputChange(e)} 

          />
          {errors.password && <span className="error-inline error-inline-pwd">{errors.password.message}</span>}
            <div className="checkbox-input">
              <div className="checkbox-right">
                <input
            type="checkbox"
            id="rememberMe"
            {...register("rememberMe")}  
          /> 
            <label htmlFor="rememberMe">Remember Me</label></div>
            <button type="submit">Login</button>
            </div>  
        </form>
          <Terms />
          </div>
        </div>
      </div>
      
    );
}